<template>
    <div class="page page-home">
    
        <Top></Top>

        <div class="hidden-xl hidden-lg navbar navbar-style-1">
            <div class="navbar-inner">
                <a v-on:click="$root.go('Inicio')" class="link back">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.439312 13.0606L5.75391 18.3752C6.04683 18.6682 6.43069 18.8146 6.81459 18.8146C7.1985 18.8146 7.58236 18.6682 7.87528 18.3752C8.46103 17.7894 8.46103 16.8397 7.87528 16.2539L5.12133 13.5H22.5C23.3284 13.5 24 12.8284 24 12C24 11.1716 23.3284 10.5 22.5 10.5H5.12133L7.87528 7.7461C8.46103 7.1603 8.46103 6.21057 7.87528 5.62477C7.28944 5.03898 6.33975 5.03898 5.75391 5.62477L0.439312 10.9394C-0.146437 11.5251 -0.146437 12.4749 0.439312 13.0606Z" fill="black"></path>
                    </svg>
                </a>
                <div class="title">Pedidos</div>
                <div class="right hidden-xs hidden-md">
                    <a v-on:click="get(true)" class="link"> 
                        <i style="font-size: 26px;" class="las la-sync-alt"></i>
                    </a>
                </div>
                <div class="right hidden-xl hidden-lg">
                    <a v-on:click="mostrarFiltro()" class="filtro-button button-large button button-fill">
                        <i class="las la-filter" v-if="!filtro"></i>
                        <span v-if="!filtro">
                            Filtros
                        </span>
                        <i class="las la-times" style="" v-if="filtro"></i>
                        <span v-if="filtro">
                            Fechar
                        </span>
                    </a>
                </div>
                <div class="subnavbar hidden-xl hidden-lg" v-if="filtro">                
                    <div class="row subnavbar-filter" v-bind:class="{'open': (filtro)}">
                        <div class="col-100">
                            <div class="list mb-0" style="margin-top: 0px">
                                <ul class="row">
                                    <li v-if="filtro" class="item-content item-input col-50">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Do dia:</div>
                                            <div class="item-input-wrap">
                                                <input type="date" placeholder="__/__/____" v-model="form.dataInicio" class="form-control">
                                                <span class="input-clear-button"></span>
                                            </div>
                                        </div>                                
                                    </li>
                                    <li v-if="filtro" class="item-content item-input col-50">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Até o dia:</div>
                                            <div class="item-input-wrap">
                                                <input type="date" placeholder="__/__/____" v-model="form.dataFinal" value="" class="form-control"/>
                                            </div>
                                        </div>
                                    </li>
                                    <li v-if="filtro" class="item-content item-input col-50">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Status:</div>
                                            <div class="item-input-wrap">
                                                <select class="form-control" v-model="form.filtro" name="filtro">                                  
                                                    <option value="" >Todos</option>
                                                    <option value="pagamento-pendente" >Pagamento pendente</option>
                                                    <option value="atendimento-agendado" >Atendimento agendado</option>
                                                    <option value="aguardando-inicio" >Aguardando paciente</option>
                                                    <option value="atendimento-em-andamento" >Atendimento em andamento</option>
                                                    <option value="atendimento-realizado" >Atendimento realizado</option>
                                                    <option value="cancelados" >Agendamento cancelado</option>
                                                </select> 
                                            </div>
                                        </div>
                                    </li>                                                  
                                    <li v-if="filtro" class="item-content item-input col-50">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Pagamento:</div>
                                            <div class="item-input-wrap">
                                                <select class="form-control" v-model="form.formaPagamento" name="formaPagamento">                                  
                                                    <option value="" selected>Todos</option>
                                                    <option value="cartao-de-credito">Cartão de crédito</option>
                                                    <option value="pix">PIX</option>
                                                </select> 
                                            </div>
                                        </div>
                                    </li>                                                
                                    <li v-if="filtro" class="item-content item-input col-50">
                                        <div class="item-inner">
                                            <h5 style="display: block; line-height: 100%; margin-top: -5px; margin-bottom: 0px;">
                                                <span style="font-size: 14px">Total:</span><br>
                                                R$ {{data.valor | toMoney}}
                                            </h5>
                                        </div>
                                    </li>
                                    <li v-if="filtro" class="item-content item-input col-50">
                                        <div class="item-inner">
                                            <button type="button" v-on:click="get" class="button-medium button button-fill" style="width: 100%; display: block;">
                                                <i class="las la-sync-alt"></i> 
                                                Buscar
                                            </button>
                                        </div>
                                    </li>
                                </ul>
                            </div>                        
                        </div>    
                    </div>
                </div>
            </div>
        </div>
        
        <div class="page-content content-area pt-70 bottom-sp70">
            <div class="container hidden-xs hidden-sm hidden-md">
            </div>

            <div class="align-items-center container hidden-md hidden-xs justify-content-space-between row">
                <div>
                    <h2>Pedidos</h2>
                </div>
                <div style="flex-direction: column;">
                    <!-- <button v-if="$root.user.tipo == 'prestador' && $root.user.empresaCod" v-on:click="$root.go('CadastrarPedidos', JSON.stringify({'t': Math.random()}))" style="float: left; width: 260px" class=" button-large button color-green button-fill mr-15">
                        <i class="las la-plus"></i>
                        <span >
                            Criar agendamento
                        </span>
                    </button> -->

                    <button v-on:click="mostrarFiltro()" class="filtro-button button-large button button-fill mr-15">
                        <i class="las la-filter" v-if="!filtro"></i>
                        <span v-if="!filtro">
                            Filtros
                        </span>
                        <i class="las la-times" style="" v-if="filtro"></i>
                        <span v-if="filtro">
                            Fechar
                        </span>
                    </button>
                </div>
            </div>

            <div class="container">
                <form v-if="filtro && $root.user.tipo != 'contratante'" class="filtro hidden-xs hidden-md" v-on:submit.prevent="form.page=1; get(true);">
                    <div class="list mb-0" style="margin-top: 0px">
                        <ul class="row">
                            <li class="col-100">
                            </li>
                            <li v-if="filtro" class="item-content item-input col-50">
                                <div class="item-inner">
                                    <div class="item-title item-label">Do dia:</div>
                                    <div class="item-input-wrap">
                                        <input type="date" placeholder="__/__/____" v-model="form.dataInicio" class="form-control">
                                        <span class="input-clear-button"></span>
                                    </div>
                                </div>                                
                            </li>
                            <li v-if="filtro" class="item-content item-input col-50">
                                <div class="item-inner">
                                    <div class="item-title item-label">Até o dia:</div>
                                    <div class="item-input-wrap">
                                        <input type="date" placeholder="__/__/____" v-model="form.dataFinal" value="" class="form-control"/>
                                    </div>
                                </div>
                            </li>
                            <li v-if="filtro" class="item-content item-input col-50">
                                <div class="item-inner">
                                    <div class="item-title item-label">Status:</div>
                                    <div class="item-input-wrap">
                                        <select class="form-control" v-model="form.filtro" name="filtro">                                  
                                            <option value="" >Todos</option>
                                            <option value="pagamento-pendente" >Pagamento pendente</option>
                                            <option value="atendimento-agendado" >Atendimento agendado</option>
                                            <option value="aguardando-inicio" >Aguardando paciente</option>
                                            <option value="atendimento-em-andamento" >Atendimento em andamento</option>
                                            <option value="atendimento-realizado" >Atendimento realizado</option>
                                            <option value="cancelados" >Agendamento cancelado</option>
                                        </select> 
                                    </div>
                                </div>
                            </li>                                                  
                            <li v-if="filtro && !$root.user.empresaCod" class="item-content item-input col-50">
                                <div class="item-inner">
                                    <div class="item-title item-label">Pagamento:</div>
                                    <div class="item-input-wrap">
                                        <select class="form-control" v-model="form.formaPagamento" name="formaPagamento">                                  
                                            <option value="" selected>Todos</option>
                                            <option value="cartao-de-credito">Cartão de crédito</option>
                                            <option value="pix">PIX</option>
                                        </select> 
                                    </div>
                                </div>
                            </li>                                                
                            <li v-if="filtro && !$root.user.empresaCod" class="item-content item-input col-50">
                                <div class="item-inner">
                                    <h5 style="display: block; line-height: 100%; margin-top: -5px; margin-bottom: 0px;">
                                        <span style="font-size: 14px">Total:</span><br>
                                        R$ {{data.valor | toMoney}}
                                    </h5>
                                </div>
                            </li>
                            <li v-if="filtro" class="item-content item-input col-50">
                                <div class="item-inner">
                                    <button type="button" v-on:click="get" class="button-medium button button-fill" style="width: 100%; display: block;">
                                        <i class="las la-sync-alt"></i> 
                                        Buscar
                                    </button>
                                </div>
                            </li>
                        </ul>
                    </div>
                </form>              
            </div>            
            <div class="">

                <div class="container">
                    <div v-if="$root.user.tipo == 'prestador' && $root.user.empresaCod" class="mt-10">
                        <button v-on:click="$root.go('CadastrarPedidos', JSON.stringify({'t': Math.random()}))" type="button" class="button button-medium button-fill mb-0">
                            <i class="las la-plus"></i>
                            Criar agendamento
                        </button>
                    </div>  

                    <!-- <button  v-if="$root.user.tipo == 'prestador' && $root.user.empresaCod"v-on:click="$root.go('CadastrarPedidos', JSON.stringify({'t': Math.random()}))" style="" class=" button-large button color-green button-fill hidden-xl hidden-md hidden-lg">
                        <i class="las la-plus"></i>
                        <span >
                            Criar agendamento
                        </span>
                    </button> -->

                    <!-- <div class="title-bar " style="margin-bottom: 0px !important; margin-top: 10px;">
                        <h5 class="dz-title " style="font-weight: 400; color: #666">
                            <i class="las la-list" style="top: 2px; position: relative;"></i>
                            Lista de agendamentos
                        </h5>
                    </div> -->
                    <div class="title-bar" v-if="$root.user.tipo == 'admin'">
                        <h5 class="dz-title">
                            Lista de pedidos
                        </h5>
                    </div>
                </div>    


                <div v-if="data.itens.length > 0 && data.loaded" class="list cart-list search-list searchbar-found item-list">
                    <ul>
                        <li class="swipeout cart-item" v-for="(item, index) in data.itens">
                            <div class="item-content swipeout-content">
                                <div class="item-inner" style="padding-bottom: 0px !important; align-items: flex-start;">
                                    <div class="item-media">
                                        <div v-if="$root.user.tipo == 'contratante'" :style="{'background-image': 'url(' + item.prestador.imagem + ')'}"></div>
                                        <div v-if="$root.user.tipo == 'prestador' || $root.user.tipo == 'admin'" :style="{'background-image': 'url(' + item.contratante.imagem + ')'}"></div>
                                    </div>
                                    <div class="item-info">
                                        <div class="item-head">
                                            <div class="item-header">
                                                PROFISSIONAL
                                            </div>
                                            <h6 class="item-title text-bold text-color-black mb-10">
                                                {{item.prestador.empresa ? item.prestador.empresa : item.prestador.nome}}
                                            </h6>
                                            <div v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'prestador'" class="item-header">
                                                PACIENTE
                                            </div>
                                            <h6 v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'prestador'" class="item-title text-bold text-color-black">
                                                {{item.contratante.nome}}
                                            </h6>
                                            <small style="display: block; line-height: 130%; margin-top: 5px; margin-bottom: 5px; font-size: 12px;">
                                                ID <b style="color: #222">#{{item.id}}</b>

                                                <small style="padding: 1px 5px; font-size: 12px; height: auto !important; background: #fff !important; color: #333; border: 1px solid #ddd;" class="badge ">
                                                    <span v-if="item.agendaTipo == 'online'">
                                                        Online
                                                    </span>
                                                    <span v-if="item.agendaTipo == 'presencial'">
                                                        Presencial
                                                    </span>
                                                    <span v-if="item.agendaTipo == 'domiciliar'">
                                                        Domiciliar
                                                    </span>                                                                                                        
                                                </small>     
                                                
                                            </small>

                                            <div class="row">
                                                <div class="col-100 large-40">
                                                    <small v-if="item.prestador.categoriasNomes" v-for="(item2, index) in item.prestador.categoriasNomes.split(',')" style="display: block; line-height: 100%; margin-bottom: 5px">
                                                        <span class="badge color-secondary">
                                                            {{item2}}
                                                        </span>
                                                    </small>                                            
                                                    <small style="display: block; line-height: 130%; margin-bottom: 2px; font-size: 12px">
                                                        STATUS
                                                    </small>

                                                    <small style="display: block; line-height: 100%; margin-bottom: 5px; " v-if="item.status == -1">
                                                        <span style="padding: 7px; font-size: 16px; height: auto !important; line-height: 130%;" class="badge color-red">
                                                            Cancelado
                                                        </span>
                                                    </small>
                                                    <small style="display: block; line-height: 100%; margin-bottom: 5px; " v-if="item.status == 0">
                                                        <span style="padding: 7px; font-size: 16px; height: auto !important; line-height: 130%;" class="badge color-orange">
                                                            Pagamento pendente
                                                        </span>
                                                    </small>
                                                    <small style="display: block; line-height: 100%; margin-bottom: 5px; " v-if="item.status == 1 && item.catalogoMetodo != 'exame'">
                                                        <span style="padding: 7px; font-size: 16px; height: auto !important; line-height: 130%;" class="badge color-orange">
                                                            Agendado
                                                        </span>
                                                    </small>
                                                    <small style="display: block; line-height: 100%; margin-bottom: 5px; " v-if="item.status == 1 && item.catalogoMetodo == 'exame'">
                                                        <span style="padding: 7px; font-size: 16px; height: auto !important; line-height: 130%;" class="badge color-orange">
                                                            Aguardando realização
                                                        </span>
                                                    </small>
                                                    <small style="display: block; line-height: 100%; margin-bottom: 5px; " v-if="item.status == 2">
                                                        <span style="padding: 7px; font-size: 16px; height: auto !important; line-height: 130%;" class="badge color-yellow">
                                                            Aguardando paciente
                                                        </span>
                                                    </small> 
                                                    <small style="display: block; line-height: 100%; margin-bottom: 5px; " v-if="item.status == 3">
                                                        <span style="padding: 7px; font-size: 16px; height: auto !important; line-height: 130%;" class="badge color-blue">
                                                            Atendimento em andamento
                                                        </span>
                                                    </small> 
                                                    <small style="display: block; line-height: 100%; margin-bottom: 5px; " v-if="item.status == 4">
                                                        <span style="padding: 7px; font-size: 16px; height: auto !important; line-height: 130%;" class="badge color-orange">
                                                            Atendimento realizado
                                                        </span>
                                                    </small> 
                                                    <small style="display: block; line-height: 100%; margin-bottom: 5px; " v-if="item.status == 5">
                                                        <span style="padding: 7px; font-size: 16px; height: auto !important; line-height: 130%;" class="badge color-green">
                                                            Atendimento realizado
                                                        </span>
                                                    </small> 
                                                </div> 
                                                <div class="col-100 large-60 hidden-xs hidden-md">

                                                    <div class=" hidden-xs hidden-md" style="margin-top: 0px; margin-bottom: 10px">
                                                        <table style="width: 100%;">
                                                            <tr>
                                                                <td v-if="item.descricao" style="width: 100%; text-align: left; padding-right: 30px; padding-left: 30px; font-size: 14px;  display: block; padding-bottom: 5px; ">
                                                                    <p style="word-break: break-word; max-width: 90%; margin-bottom: 0px; margin-top: 0px; color: #000; line-height: 130% !important;">
                                                                        <b>Serviço: </b>{{item.descricao}}
                                                                    </p>
                                                                </td>
                                                            </tr>                                                                 
                                                            <tr v-if="item.formaPagamento && $root.user.tipo == 'admin'">
                                                                <td style="width: 69%; text-align: left; padding-right: 30px; padding-left: 30px; font-size: 14px;">
                                                                    <i class="las la-money-bill"></i> 
                                                                    Valor do <b>atendimento</b>:   <b style="font-size: 14px; color: #222">R$ {{item.total | toMoney}}</b>
                                                                </td>
                                                            </tr>
                                                            <tr v-if="item.data != '0000-00-00'">
                                                           
                                                                <td style="text-align: left; padding-right: 30px; padding-left: 30px; font-size: 14px">
                                                                    <i class="las la-clock"></i> 
                                                                    Agendado para:   <b style="font-size: 14px; color: #222">{{item.data | formatDate}} {{item.horaInicio.substr(0, 5)}}h</b>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                    <div style="padding-left: 30px; padding-right: 30px; justify-content: flex-end;" class="row">
                                                        <button v-on:click="$root.go('DetalhesPedidos', JSON.stringify({'c': item.cod}))" type="button" class="col-100 button button-medium color-primary button-fill" style="display: block; width: 100%; ">
                                                            <i class="las la-external-link-alt"></i>
                                                            Ver detalhes
                                                        </button>
                                                    </div>

                                                </div>
                                            </div> 
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="item-foot hidden-lg hidden-xl" style="margin-top: 0px; margin-bottom: 10px">
                                <table style="width: 100%;">
                                    <tr>
                                        <td v-if="item.descricao" colspan="2" style="width: 100%; text-align: left; padding-right: 30px; padding-left: 30px; font-size: 14px;  display: block; padding-bottom: 5px; ">
                                            <p style="word-break: break-word; max-width: 90%; margin-bottom: 0px; margin-top: 0px; color: #000; line-height: 130% !important;">
                                                <b>Serviço: </b>{{item.descricao}}
                                            </p>
                                        </td>
                                    </tr>                                         
                                    <tr v-if="item.formaPagamento && $root.user.tipo == 'admin'">
                                        <td colspan="2" style="width: 69%; text-align: right; padding-right: 30px; font-size: 14px;">
                                            <i class="las la-money-bill"></i> 
                                            Valor do <b>atendimento</b>:   <b style="font-size: 14px; color: #222">R$ {{item.total | toMoney}}</b>
                                        </td>
                                    </tr>
                                    <tr v-if="item.data != '0000-00-00'">
                                        <td colspan="2" style="text-align: left; padding-right: 30px; padding-left: 30px; font-size: 14px">
                                            <i class="las la-clock"></i> 
                                            Agendado para:   <b style="font-size: 14px; color: #222">{{item.data | formatDate}} {{item.horaInicio.substr(0, 5)}}h</b>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div class=" hidden-lg hidden-xl" style="padding-left: 30px; padding-right: 30px">
                                <button v-on:click="$root.go('DetalhesPedidos', JSON.stringify({'c': item.cod}))" type="button" class="button button-medium color-primary button-fill" style="display: block; width: 100%; ">
                                    <i class="las la-external-link-alt"></i>
                                    Ver detalhes
                                </button>
                            </div>
                        </li>                          
                    </ul>
                </div>

                <div class="empty" v-if="data.itens.length == 0 && data.loaded" style="margin-top: 20vh">
                    <center>
                        <img src="static/images/empty.svg" style="width: 80%">
                        <p class="mt-0 pt-0">
                            <i class="las la-times"></i>
                            Nenhum resultado encontrado.
                        </p>
                    </center>
                </div>      



            </div>

        </div>
        <Toolbar></Toolbar>
    </div>
</template>

<script>
import Toolbar from './Toolbar'
import Top from './Top'
export default {
    name: 'Pedidos',
    components: {
        'Toolbar': Toolbar,
        'Top':  Top
    },          
    filters: {
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2});
            } else {
                return "0,00";
            }
            // return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
        },        
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }
            // return formatDate(value.replace(" ", "T")) + " " + formatHours(value.replace(" ", "T"));
            return date + (time ? (" " + time) : "");
        }
    },        
    data () {
        var self                    = this;
        return {
            "filtro":               false,
            "tempoResposta":        null,
            "viagem":               null,
            "tab":                  "pendentes",
            "empresas":             {
                "itens":            []
            },
            "data":                 {
                "pages":            [],
                "itens":            []
            },
            "loading": {
                "submit":           false
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "filtro":           "",
                "formaPagamento":   "",
                "page":             1
            }              
        }
    },
    methods: {  
        mostrarFiltro: function() {
            var  self = this;
            self.filtro = (self.filtro ? false : true);            
            self.$forceUpdate();
        },               
        verQrcode: function(cod, texto) {
            var self = this;
            console.log("verQrcode()", texto);
            $("#qrcode-" + cod).show();
            $("#qrcode-" + cod).html("");
            var qrcode = new QRCode("qrcode-" + cod, {
                text: texto,
                // width: 128,
                // height: 128,
                colorDark : "#000000",
                colorLight : "#ffffff",
                correctLevel : QRCode.CorrectLevel.L
            });            
        },
        mostrarEndereco: function(item) {
            var  self = this;
            item.endereco = (item.endereco ? false : true);            
            self.$forceUpdate();
        },
        chevron: function(item) {
            var  self = this;
            item.mostrar = (item.mostrar ? false : true);            
            self.$forceUpdate();
        },     
        ligar: function(tel) {
            var self = this;
            console.log("ligar()", tel);
            window.open("tel:" + tel, "_system");
        }, 
        get: function(e) {
            var self        = this;
            console.log("get()", self.form);
            if (e) loading.show();
            return new Promise(function(resolve, reject) {

                axios.get("api/pedidos-v2.php", {params: self.form})
                .then(response => {
                    
                    console.log("get() response", response);
                    // response.data = {
                    //     "result": {
                    //         "itens": [],
                    //         "loaded": true
                    //     }
                    // };
                    self.data   = response.data.result; 
                    if (e) loading.hide();
                    self.$forceUpdate();
                    resolve(response.data.result);
                    // self.$root.scrollTop();                    
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    if (e) loading.hide();
                    reject(error);
                    // alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },        
        cancelar: function(cod) {
            
            console.log("cancelar()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja cancelar?", function() {
                var texto               = prompt("Qual o motivo do cancelamento?");
                if (!texto)             return false; 
                self.loading.cancelar   = true;
             
                var form = {
                    "_cod":         self.$root.user.cod, 
                    "_token":       self.$root.user.token,
                    "cod":          cod,
                    "status":       "cancelar",
                    "texto":        texto
                };                

                loading.show();
                
                axios.put("api/pedidos-v2.php", form)
                .then(response => {
                    console.log("cancelar() response", response)
                    self.loading.cancelar    = false;
                    self.get(true);
                    alert(response.data.message);
                })
                .catch(error => {
                    console.log("cancelar() error", error)
                    loading.hide();
                    self.loading.cancelar    = false;
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },
        alterarStatus: function(cod, status, message) {
            console.log("alterarStatus()", cod);
            
            var self                = this;
            
            if (self.timerResposta && status == "pronto-para-entrega") {
                alert("Aguarde, por favor.. você só pode procurar entregadores de um pedido por vez")
                return false;
            }

            var form = {
                "_cod":         self.$root.user.cod, 
                "_token":       self.$root.user.token,
                "cod":          cod,
                "status":       status
            };                

            loading.show();
            
            axios.put("api/pedidos-v2.php", form)
            .then(response => {
                console.log("finalizar() response", response)
                loading.hide();
                // self.get(true);
                if (message) alert(response.data.message);

                if (status == "pronto-para-entrega") {
                    self.viagem = response.data.result;
                    self.initTimerResposta();
                }

            })
            .catch(error => {
                console.log("finalizar() error", error)
                loading.hide();
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });
        }                
    },
    created: function() {
        var self = this;


        // if (self.$root.realtime.channelUsuario) {
        //     console.log("fez unbind pusher")
        //     self.$root.realtime.channelUsuario.unsubscribe("pedidos-usuario-" + self.form._cod);
        //     self.$root.realtime.channelUsuario.unbind("update");
        // }
        // self.$root.realtime.channelUsuario    = self.$root.realtime.client.subscribe("pedidos-usuario-" + self.form._cod);
        // self.$root.realtime.channelUsuario.bind("update", function(data) {
        //     console.log("atualizacao no pedido", data);

        //     var existe = false;
        //     self.data.itens.forEach(function(item, index) {
        //         if (item.cod == data.pedido.cod) {
        //             console.log("achou", item);
        //             data.pedido.mostrar     = item.mostrar ? item.mostrar : false;
        //             self.data.itens[index]  = data.pedido;
        //             self.$forceUpdate();
        //             existe = true;
        //             self.$root.beep();
        //         }
        //     });
        //     if (!existe) {
        //         console.log("Nao existe o pedido na lista, entao faz get e toca beep")
        //         self.get(true).then(function() {
        //             self.$root.beep();
        //         });
        //     }
            
        // });

        // Pusher.logToConsole     = false;
        
        // self.realtime           = {};
        // self.realtime.client    = new Pusher(self.$root.config.pusher.key, {
        //     cluster: 'mt1',
        //     activityTimeout: 2000,
        //     // enabledTransports: ['ws']                
        // });
        // self.realtime.channelUsuario    = self.realtime.client.subscribe("pedidos-usuario-" + self.form._cod);
        // self.realtime.channelUsuario.bind("update", function(data) {
        //     console.log("atualizacao no pedido", data);

        //     var existe = false;
        //     self.data.itens.forEach(function(item, index) {
        //         if (item.cod == data.pedido.cod) {
        //             console.log("achou", item);
        //             data.pedido.mostrar     = item.mostrar ? item.mostrar : false;
        //             self.data.itens[index]  = data.pedido;
        //             self.$forceUpdate();
        //             existe = true;
        //             self.$root.beep();
        //         }
        //     });
        //     if (!existe) {
        //         console.log("Nao existe o pedido na lista, entao faz get e toca beep")
        //         self.get(true).then(function() {
        //             self.$root.beep();
        //         });
        //     }
            
        // });

    },
    activated: function() {
        var self = this;

        console.log("activated>");


        if (self.$root.realtime.channelUsuario) {
            console.log("fez unbind pusher")
            self.$root.realtime.channelUsuario.unsubscribe("pedidos-usuario-" + self.form._cod);
            self.$root.realtime.channelUsuario.unbind("update");
        }
        self.$root.realtime.channelUsuario    = self.$root.realtime.client.subscribe("pedidos-usuario-" + self.form._cod);
        self.$root.realtime.channelUsuario.bind("update", function(data) {
            console.log("atualizacao no pedido", data);

            var existe = false;
            self.data.itens.forEach(function(item, index) {
                if (item.cod == data.pedido.cod) {
                    console.log("achou", item);
                    data.pedido.mostrar     = item.mostrar ? item.mostrar : false;
                    self.data.itens[index]  = data.pedido;
                    self.$forceUpdate();
                    existe = true;
                    self.$root.beep();
                }
            });
            if (!existe) {
                console.log("Nao existe o pedido na lista, entao faz get e toca beep")
                self.get(true).then(function() {
                    self.$root.beep();
                });
            }
            
        });

        loading.show();
        self.get(true).then(function() {
                          
            loading.hide();
        }).catch(function(error) {
            console.log("erro ao buscar", error);
            loading.hide();
        });

    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped="">
    
    .desativada {
        opacity: 0.6 !important; 
        pointer-events: none !important;        
    }

    .tag-list {
        margin-bottom: 0px !important;
        margin-top: 0px;
    }

    .item-title {
        margin-bottom: 0px !important;
        line-height: 130%;
        font-weight: 500;
        font-size: 16px;
    }
    .chip-label {
        font-weight: bold;
        font-size: 12px !important;
    }
    .chip {
        line-height: 18px !important;
        height: auto !important;
        min-height: 18px !important;
        /*padding-bottom: 0px;*/
        /*padding-top: 0px;*/
        margin-top: -4px;
        margin-left: -2px;
        margin-bottom: 5px;
    }
    .dz-media {
        margin-bottom: 5px !important;
    }
    .tabbar.tab-style-2 .tab-link:after {
        display: none !important;
    }

    .banner {
        background: var(--f7-theme-color);
        padding: 20px;
        margin-bottom: 30px;
    }

    .banner h4 {
        color: #fff;
        line-height: 130%;
        padding: 0px !important;
        margin: 0px !important;
    }

    .banner p {
        color: #fff;
        line-height: 130%;
        padding: 0px !important;
        margin: 0px !important;
    }    

    .img-perfil {
        width: 50px;
        height: 50px;
        background-size: cover;
        background-position: center;
        border: 1px solid #ddd;
        border-radius: 6px;
        display: inline-block;
    }    

    .col-50-grid {
      margin: 0;
      display: grid;
      grid-template-rows: 1fr auto;
      margin-bottom: 10px;
      break-inside: avoid;    
    }

    .row-grid {
      column-count: 2;
      column-gap: 20px;
    }
  
    .item-bx.item-grid {
        margin-bottom: 15px;
    }         

    .categories-bx.active {
        background: #f8b832 !important;
        color: #222 !important;
    }

    .cart-list-area {
        padding-left: 0;
        padding-right: 0;
    }

    .cart-list {
        overflow: hidden;
        margin: 0;
    }

    .cart-item {
        background-color: #fff;
        overflow: unset;
        margin: 6px 0;
        border-bottom: 1px solid #ddd;
        padding-bottom: 20px;        
    }        
   
    .cart-item .item-inner {
        background-color: #fff;
        padding: 12px 30px;
    }   

    .cart-item .item-media {
        min-width: 95px !important;
        width: 95px;
        position: relative;
        padding: 0;
        border-radius: 16px;
        overflow: hidden;
        margin-right: 20px;
        height: 115px;
        align-items: flex-start;
        height: 105px;
        margin-top: 10px;
    }

    .cart-item .item-media img {
        width: 100%;
    }

    .cart-item .item-media .item-price {
        background-color: var(--f7-theme-color);
        color: #fff;
        position: absolute;
        bottom: 0;
        margin: 0;
        width: 100%;
        left: 0;
        text-align: center;
        font-weight: 500;
        font-size: 16px;
        padding: 5px;
        border-radius: 16px;
        box-sizing: border-box;
    }

    .cart-item .item-info {
        width: 100%;
        justify-content: space-between;
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: 5px 0;
        box-sizing: border-box;
    }

    .cart-item .item-foot {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .cart-item .item-foot .item-total {
        margin: 0;
        font-weight: 500;
        font-size: 16px;
    }                        

    .cart-item .item-content {
        padding-left: 0;
        transition: all 0.5s;
    }

    .cart-item .item-head .category {
        margin: 0;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.6);
    }

    .cart-item .item-title a {
        color: #000;
        word-break: break-word;
        white-space: break-spaces;
        text-overflow: ellipsis;
        display: block;
        line-height: 130%;
    }

    .cart-item .item-title {
        font-weight: 500;
        margin: 0 0 10px;
    }        

    .cart-item .item-media div {
        width: 100%;
        height: 100%;
        background-size: cover !important;
        background-position: center;
        background: #efefef;
        border-radius: 6px;
    }

    .badge-small {
        display: inline-block; 
        line-height: 100%; 
        float: right;
    }


    .badge-small .badge {
        padding: 4px 7px; 
        font-size: 11px; 
        height: auto !important; 
        background: #ddd; 
        color: #333;        
    }

    @media only screen and (min-width: 992px) and (max-width: 1920px) {
        .badge-small {
            margin-right: 30px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Pedidos.vue